import { useJsApiLoader } from '@react-google-maps/api'
import { createContext } from 'react'

import { useMapApiKey } from 'src/shared/api/google-maps/use-map-api-key'

interface GoogleMapsContextType {
  isLoaded: boolean
}

export const GoogleMapsContext = createContext<GoogleMapsContextType>({
  isLoaded: false,
})

export function GoogleMapsProvider({ children }: { children: React.ReactNode }) {
  const { data: mapApiKey } = useMapApiKey()
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: mapApiKey,
    libraries: ['places'],
  })

  return <GoogleMapsContext.Provider value={{ isLoaded }}>{children}</GoogleMapsContext.Provider>
}
